export const ROUTE_PATHS = {
  HOME: '/',
  COMPANY: '/company',
  PHILOSOPHY: '/philosophy',
  FOUNDER: '/founder',
  BUSINESS: '/business',
  COMPLIANCE: '/compliance',
  MULTICULTURAL: '/multicultural',
  CONTACT: '/contact',
  EN_PREFIX: '/en',
  EN_HOME: '/en',
  EN_COMPANY: '/en/company',
  EN_PHILOSOPHY: '/en/philosophy',
  EN_FOUNDER: '/en/founder',
  EN_BUSINESS: '/en/business',
  EN_COMPLIANCE: '/en/compliance',
  EN_MULTICULTURAL: '/en/multicultural',
  EN_CONTACT: '/en/contact',
} as const;

export type LanguageCode = 'jp' | 'en';

export interface Language {
  code: LanguageCode;
  label: string;
}

export const LANGUAGES: Language[] = [
  { code: 'jp', label: '日本語' },
  { code: 'en', label: 'English' },
];

export const COMPANY_INFO = {
  name: {
    jp: '株式会社M.M.K',
    en: 'M.M.K Co., Ltd.',
  },
  representative: {
    jp: '秦佳玲',
    en: 'Qin Jialing',
  },
  established: {
    jp: '2025年2月',
    en: 'February 2025',
  },
  capital: {
    jp: '500万円（事業拡大に応じた資本強化を予定しています）',
    en: '5 million JPY (Capital enhancement planned according to business expansion)',
  },
  location: {
    jp: '大阪府大阪市天王寺区',
    en: 'Tennoji-ku, Osaka, Japan',
  },
  email: 'mmk221.2025@gmail.com',
  catHotelUrl: 'https://catretreat-nekojarashi.jp',
  copyright: '© 2026 株式会社M.M.K All Rights Reserved.',
} as const;

export function getLocalizedPath(path: string, lang: LanguageCode): string {
  const cleanPath = path.startsWith('/en') ? path.replace('/en', '') : path;
  const base = cleanPath === '' ? '/' : cleanPath;
  return lang === 'en' ? `/en${base === '/' ? '' : base}` : base;
}

export function isEnglishPath(path: string): boolean {
  return path.startsWith('/en');
}